var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-card', {
    staticClass: "pr-12 pl-12 pt-7 pb-7",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold"
  }, [_vm._v(" Neues Passwort ")])]), _vm.initialCode === '' ? _c('v-card-text', {
    staticClass: "mb-n1"
  }, [_vm._v(" Falls Sie uns aufgefordert haben, ihr Passwort zurückzusetzen, haben wir Ihnen einen Code zugesendet. Bitte geben Sie diesen an und setzen Sie eine neues Passwort. ")]) : _vm._e(), _c('v-card-text', [_c('v-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-Mail",
      "type": "mail",
      "rules": _vm.emailRules,
      "prepend-icon": "mdi-account-circle",
      "id": "mail"
    },
    model: {
      value: _vm.mail,
      callback: function callback($$v) {
        _vm.mail = $$v;
      },
      expression: "mail"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Code",
      "rules": _vm.required,
      "prepend-icon": "mdi-counter",
      "id": "code"
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Neues Passwort",
            "type": _vm.isPasswordVisible2 ? 'text' : 'password',
            "rules": _vm.passwordRequirements,
            "prepend-icon": "mdi-lock",
            "append-icon": _vm.isPasswordVisible2 ? 'mdi-eye' : 'mdi-eye-off',
            "id": "password1"
          },
          on: {
            "click:append": function clickAppend($event) {
              _vm.isPasswordVisible2 = !_vm.isPasswordVisible2;
            }
          },
          model: {
            value: _vm.password1,
            callback: function callback($$v) {
              _vm.password1 = $$v;
            },
            expression: "password1"
          }
        }, on))];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.specialChars))])]), _c('v-text-field', {
    attrs: {
      "label": "Neues Passwort wiederholen",
      "type": _vm.isPasswordVisible3 ? 'text' : 'password',
      "rules": _vm.passwordRepeatRule,
      "prepend-icon": "mdi-lock",
      "append-icon": _vm.isPasswordVisible3 ? 'mdi-eye' : 'mdi-eye-off',
      "id": "password2"
    },
    on: {
      "click:append": function clickAppend($event) {
        _vm.isPasswordVisible3 = !_vm.isPasswordVisible3;
      }
    },
    model: {
      value: _vm.password2,
      callback: function callback($$v) {
        _vm.password2 = $$v;
      },
      expression: "password2"
    }
  }), _c('LoginPasswordRequirementList', {
    attrs: {
      "password": _vm.password1,
      "setRequirementsFullfilled": _vm.setRequirementsFullfilled
    }
  }), _vm.failure ? _c('h3', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.failureText) + " ")]) : _vm._e(), _vm.success ? _c('h3', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.successText) + _vm._s(_vm.countdown))]) : _vm._e(), _c('div', {
    staticClass: "mt-5 mb-7"
  }, [_c('v-btn', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isResetButtonDisabled,
      "type": "submit",
      "data-test-reset": "",
      "outlined": ""
    }
  }, [_vm._v(" Zurücksetzen ")])], 1), _c('v-btn', {
    staticClass: "backButton",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.backToLogin();
      }
    }
  }, [_vm._v(" Zurück zum Login")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }